module.exports = __webpack_public_path__ + "img/logo-dark.0e5676dd.png";